<template>
  <div class="main print-no-padding apply-prescription">
    <h2 class="is-print-hide title-area">
      <span class="main-title">申请处方</span>
      <span class="price" v-if="isStoredValueDrugstore && price">{{ `${price}点/次` }}</span>
    </h2>
    <breadcrumb firstName="申请处方" :secondName="secondName"></breadcrumb>

    <el-card class="prescription-wrapper">
      <patient-info
        ref="patientInfo"
        :maxAge="maxAge"
        @initPastHistory="initPastHistory"
        @checkCaseHistoryUploadRemind="checkCaseHistoryUploadRemind"
      />
      <drug-info
        v-if="!nwVideo"
        ref="drugInfo"
        @refreshDrugInfo="refreshDrugInfo"
        :showError="showDrugInfoError"
        :drugInfoList="drugInfoList"
        :options="{ drugUsages, perUnits, units, usageFrequencyNames }"
        :drugWarn="drugWarn"
      />
      <disease-info
        v-if="isOldProcess"
        :title="`${nwVideo ? 2 : 3}.疾病信息`"
        :showSymptomTags="showSymptomTags"
        :symptomTags="symptomTags"
        :showDiagnoseTags="showDiagnoseTags"
        :diagnoseTags="diagnoseTags"
        :showSymptomError="showSymptomError"
        :showDiagnoseError="showDiagnoseError"
        :isCustomizedSymptom="isCustomizedSymptom"
        :isCustomizedDiagnose="isCustomizedDiagnose"
      />
      <multi-disease-info
        v-else
        ref="multiDiseaseInfo"
        :title="`${nwVideo ? 2 : 3}.疾病信息（多选）`"
        :drugsSymptomsAndIllnesses="drugsSymptomsAndIllnesses"
        :isHighRis="!!isHighRis"
      />

      <past-medical-history
        :hepatonephricStatus="hepatonephricStatus"
        :diseaseHistoryStatus="diseaseHistoryStatus"
        :diseaseHistory="diseaseHistory"
        @changePastHistory="changePastHistory"
        @handleHepatonephricStatus="handleHepatonephricStatus"
        @handleDiseaseHistoryStatus="handleDiseaseHistoryStatus"
        @handleMedicalInsuranceStatus="handleMedicalInsuranceStatus"
        :hepatonephricConfig="hepatonephricConfig"
        :medical-insurance-status="modifyRestriction"
        :has-modify-restriction="hasModifyRestriction"
      />
      <case-info
        @addCaseInfo="addCaseInfo"
        @removeCaseInfo="removeCaseInfo"
        :file-list="medicalRecordImg"
        :remindText="remindText"
        :remindLevel="remindLevel"
      />
      <el-button class="button--larger" type="primary" @click="handlerClickApply($route.params.consultType)">
        发起问诊
      </el-button>
    </el-card>
    <img v-show="false" :src="loadingSrc" alt="" />
    <el-dialog class="ai-loading-dialog" :visible.sync="dialogVisible" width="282px" :close-on-click-modal="false">
      <div class="loading-content">
        <div class="loading-icon">
          <img :src="loadingSrc" />
        </div>
        <div class="loading-message">{{ loadingText }}</div>
      </div>
    </el-dialog>

    <popSendCode
      :show="showSendCode"
      title="实名验证"
      :info="showSendCodeMsg"
      :mobile="showCodeMobile"
      @close="onSendClose"
      @success="onSendSuccess"
    />
  </div>
</template>

<script>
import { MessageBox } from 'element-ui';
import patientInfo from './components/patientInfo';
import drugInfo from './components/drugInfo';
import diseaseInfo from './components/diseaseInfo';
import multiDiseaseInfo from './components/multiDiseaseInfo';
import pastMedicalHistory from './components/pastMedicalHistory';
import caseInfo from './components/caseInfo';
import MessageHint from '../../components/messageHint';
import breadcrumb from '@/components/global/breadcrumb';
import { ACTION_TYPE, TAG_KEY_MAP, CARD_MODE } from './constants';
import { prescriptionTypeNames, CONSULT_TYPE } from '../../constants';
import Fetch from '@/api';
import { isEmpty, getLocationByAMap } from '@/util';
import { mapState, mapGetters } from 'vuex';
import popSendCode from '@/components/popSendCode.vue';

const mergeTags = (tags, customTags) => {
  const tagsObj = tags.reduce((obj, tag) => {
    return { ...obj, [tag.text]: tag.active };
  }, {});
  const customTagsObj = customTags.reduce((obj, tag) => {
    return { ...obj, [tag.text]: tag.active };
  }, {});

  const mergeObj = { ...tagsObj, ...customTagsObj };

  return Object.keys(mergeObj).map(k => ({
    text: k,
    active: mergeObj[k]
  }));
};

let Timer = null;
let selfJump = false;
export default {
  name: 'applyPrescription',
  components: {
    patientInfo,
    drugInfo,
    diseaseInfo,
    multiDiseaseInfo,
    pastMedicalHistory,
    caseInfo,
    breadcrumb,
    popSendCode
  },
  provide() {
    return {
      [ACTION_TYPE.ADD_DRUG_INFO]: this[ACTION_TYPE.ADD_DRUG_INFO],
      [ACTION_TYPE.EDIT_DRUG_INFO]: this[ACTION_TYPE.EDIT_DRUG_INFO],
      [ACTION_TYPE.UPDATE_DRUG_INFO]: this[ACTION_TYPE.UPDATE_DRUG_INFO],
      [ACTION_TYPE.DELETE_DRUG_INFO]: this[ACTION_TYPE.DELETE_DRUG_INFO],
      [ACTION_TYPE.ADD_TAG]: this[ACTION_TYPE.ADD_TAG],
      [ACTION_TYPE.SELECT_TAG]: this[ACTION_TYPE.SELECT_TAG],
      [ACTION_TYPE.REMOVE_TAG]: this[ACTION_TYPE.REMOVE_TAG]
    };
  },
  data() {
    return {
      drugInfoList: [],
      showSymptomTags: [],
      symptomTags: [],
      customSymptomTags: [],
      showDiagnoseTags: [],
      diagnoseTags: [],
      customDiagnoseTags: [],
      drugUsages: [],
      perUnits: [],
      units: [],
      usageFrequencyNames: [],
      showDrugInfoError: false,
      showSymptomError: false,
      showDiagnoseError: false,
      price: '',
      secondName: '',
      dialogVisible: false,
      loadingSrc: require('@/assets/img/icon_ai_loading.gif'),
      loadingText: '正在加载中',
      // 是否自定义症状
      isCustomizedSymptom: true,
      // 是否自定义诊断
      isCustomizedDiagnose: true,
      // 病历
      medicalRecordImg: [],
      // 肝肾功能
      hepatonephricStatus: true,
      // 是否有过往病史
      diseaseHistoryStatus: false,
      // 过往病史
      diseaseHistory: [],
      // 是否展示肝肾功能
      hepatonephricConfig: true,
      // 是否需要病历提醒
      remindLevel: 0,
      // 是否高风险药品
      isHighRis: false,
      // 医保报销要求 0:不限制 1:不可修改 2:只允许修改诊断 3:只允许修改用法用量
      modifyRestriction: 0,
      // 是否展示医保报销
      hasModifyRestriction: false,
      wechatAdvResult: {},
      isSeparateDisplay: false,
      drugsSymptomsAndIllnesses: [],
      drugWarn: {},
      showSendCode: false,
      showCodeMobile: '',
      showSendCodeMsg: '你申请的药品输入高风险药品，需实名登记后购买',
      applyType: '',
      maxAge: 199
    };
  },
  computed: {
    ...mapState('nwVideo', ['nwVideo']),
    ...mapState('video', ['isStartLocalCamera']),
    ...mapState('global', ['userInfo']),
    ...mapGetters({
      // vsPubSub: 'video_trtcVideoStore/getVsPubSub',
      // vsEvent: 'video_trtcVideoStore/getVsEvent'
    }),
    isStoredValueDrugstore() {
      const roleList = this.$store.getters.roleListFromBk;
      const storeList = this.$store.getters.storeList;
      const role = roleList.find(role => role.storeIds.length > 0);
      if (role) {
        const store = storeList.find(store => store.id === role.storeIds[0]);
        if (store) {
          const { isExpire, type } = store;
          return type === 2 && !isExpire;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    isExpire() {
      const roleList = this.$store.getters.roleListFromBk;
      const storeList = this.$store.getters.storeList;
      const role = roleList.find(role => role.storeIds.length > 0);
      if (role) {
        const store = storeList.find(store => store.id === role.storeIds[0]);
        if (store) {
          const { isExpire } = store;
          return isExpire;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    remindText() {
      const { remindLevel, isHighRis } = this;
      if (isHighRis || remindLevel > 0) {
        if (isHighRis) {
          return '请上传首诊凭证（新冠特效药请上传核酸或抗原阳性证明）';
        }
        return '请上传首诊凭证（新冠特效药请上传核酸或抗原阳性证明）';
      } else {
        return '';
      }
    },
    isOldProcess() {
      return !this.isSeparateDisplay || this.nwVideo;
    }
  },
  async mounted() {
    this.$player.$on('applyPrescription', type => {
      this.applyPrescription(type);
    });
    await this.$store.dispatch('global/setNeedIdNo');
    await this.checkDisplay();
    await this.fetchDrugOption();
    await this.getServicePrice();
    await this.applyAdvisoryPageInit();
  },
  methods: {
    [ACTION_TYPE.ADD_DRUG_INFO](info) {
      this.drugInfoList = this.drugInfoList.concat(info);
      this.showDrugInfoError = false;
    },
    [ACTION_TYPE.EDIT_DRUG_INFO](info) {
      this.drugInfoList = this.drugInfoList.map(drug => {
        if (drug.id === info.id) {
          return { ...drug, ...info };
        }
        return drug;
      });
    },
    [ACTION_TYPE.UPDATE_DRUG_INFO](info, callback, isSave = true) {
      if (isSave) {
        Telescope.trackEvent({
          trackId: 'zywzpc-save-drug',
          custom: { name: info.name, drugProductDTOS: info.drugProductDTOS }
        });
        return Fetch.save_drug(info.name, info.drugProductDTOS).then(res => {
          const { drugProductDTOS } = res;
          Telescope.trackEvent({ trackId: 'zywzpc-selected-spu', custom: { spu: drugProductDTOS } });
          if (info.from === CARD_MODE.NEW) {
            Fetch.check_drug(info.name, this.drugInfoList.map(drug => drug.name).filter(Boolean))
              .then((res = {}) => {
                this.drugWarn = (res.drugWarnList || []).reduce((pre, cur) => {
                  pre[cur.drugName] = cur.riskWarnMsg;
                  return pre;
                }, {});
                typeof callback === 'function' && callback();
              })
              .then(() => {
                this.drugInfoList = this.drugInfoList.map(drug => {
                  if (drug.id === info.id) {
                    info.drugProductDTOS[0].id = drugProductDTOS[0]?.id;
                    info.drugProductDTOS[0].name = drugProductDTOS[0]?.name;
                    info.drugProductDTOS[0].initial = drugProductDTOS[0]?.initial;
                    info.drugProductDTOS[0].companyId = drugProductDTOS[0]?.companyId;
                    info.drugProductDTOS[0].drugId = drugProductDTOS[0]?.drugId;
                    info.drugBarcodeId = drugProductDTOS[0].drugBarcodeDTOS[0]?.id;
                    return { ...drug, ...info };
                  }
                  return drug;
                });
                this.checkDisplay().then(() => {
                  this.getTags();
                });
                this.checkCaseHistoryUploadRemind();
              });
          } else {
            this.drugInfoList = this.drugInfoList.map(drug => {
              if (drug.id === info.id) {
                info.drugProductDTOS[0].id = drugProductDTOS[0].id;
                info.drugProductDTOS[0].name = drugProductDTOS[0].name;
                info.drugProductDTOS[0].initial = drugProductDTOS[0].initial;
                info.drugProductDTOS[0].companyId = drugProductDTOS[0].companyId;
                return { ...drug, ...info };
              }
              this.checkCaseHistoryUploadRemind();
              return drug;
            });
          }

          return info.drugProductDTOS[0];
        });
      } else {
        this.drugInfoList = this.drugInfoList.map(drug => {
          if (drug.id === info.id) {
            return { ...drug, ...info };
          }
          return drug;
        });
        this.checkCaseHistoryUploadRemind();
      }
    },
    [ACTION_TYPE.DELETE_DRUG_INFO](id) {
      this.drugInfoList = this.drugInfoList.filter(drug => drug.id !== id);
    },
    [ACTION_TYPE.ADD_TAG](text, tagProperty) {
      const showTagKey = TAG_KEY_MAP[tagProperty].show;
      const customTagKey = TAG_KEY_MAP[tagProperty].custom;
      const errorTagKey = TAG_KEY_MAP[tagProperty].error;

      const item = { text, active: true };
      this[customTagKey] = this[customTagKey].concat(item);
      const isExist = this[showTagKey].filter(tag => tag.text === text).length > 0;
      if (isExist) {
        this[showTagKey] = this[showTagKey].map(tag => {
          return tag.text === text ? { ...tag, active: true } : tag;
        });
      } else {
        this[showTagKey] = this[showTagKey].concat(item);
      }
      this[errorTagKey] = false;
    },
    [ACTION_TYPE.SELECT_TAG](text, tagProperty) {
      const showTagKey = TAG_KEY_MAP[tagProperty].show;
      const customTagKey = TAG_KEY_MAP[tagProperty].custom;
      const errorTagKey = TAG_KEY_MAP[tagProperty].error;

      this[showTagKey] = this[showTagKey].map(tag => {
        return tag.text === text ? { ...tag, active: true } : tag;
      });
      this[customTagKey] = this[customTagKey].map(tag => {
        return tag.text === text ? { ...tag, active: true } : tag;
      });
      this[errorTagKey] = false;
    },
    [ACTION_TYPE.REMOVE_TAG](text, tagProperty) {
      const showTagKey = TAG_KEY_MAP[tagProperty].show;
      const customTagKey = TAG_KEY_MAP[tagProperty].custom;
      this[showTagKey] = this[showTagKey].map(tag => {
        return tag.text === text ? { ...tag, active: false } : tag;
      });
      this[customTagKey] = this[customTagKey].map(tag => {
        return tag.text === text ? { ...tag, active: false } : tag;
      });
    },
    refreshDrugInfo() {
      this.checkCaseHistoryUploadRemind();
      this.checkDisplay().then(() => {
        this.getTags();
      });
    },
    getTags() {
      if (this.isOldProcess) {
        this.fetchDrugTags();
      } else {
        this.fetchNewDrugTags();
      }
    },
    checkDisplay() {
      const drugIds = this.drugInfoList.map(drug => drug.drugId).filter(Boolean);
      return Fetch.isSeparateDisplay({ drugIds }).then(res => {
        this.isSeparateDisplay = res.isSeparateDisplay;
      });
    },
    addCaseInfo(file) {
      this.medicalRecordImg.push(file);
    },
    removeCaseInfo(file) {
      this.medicalRecordImg = this.medicalRecordImg.filter(o => o.uid !== file.uid);
    },
    handleHepatonephricStatus(val) {
      this.hepatonephricStatus = val;
    },
    handleDiseaseHistoryStatus(val) {
      this.diseaseHistoryStatus = val;
    },
    handleMedicalInsuranceStatus(val) {
      this.modifyRestriction = val;
    },
    fetchDrugOption() {
      Fetch.get_drug_option().then(({ drugUsages, perUnits, units, usageFrequencyNames }) => {
        this.drugUsages = drugUsages.map(o => ({
          label: o.name,
          value: o.name,
          children: o.child.map(c => ({ label: c, value: c }))
        }));
        this.perUnits = perUnits.map(o => ({ label: o, value: o }));
        this.units = units.map(o => ({ label: o, value: o }));
        this.usageFrequencyNames = usageFrequencyNames.map(o => ({ label: o, value: o }));
      });
    },
    // 获取药品是否是高风险药品
    async isHighRiskDrug(drugIds) {
      try {
        const { isHighRis } = await Fetch.isHighRiskDrug({ drugIds });
        // 高风险药品不可以自定义症状和诊断
        this.isCustomizedSymptom = !isHighRis;
        this.isCustomizedDiagnose = !isHighRis;
        this.isHighRis = isHighRis;
        if (isHighRis) {
          // 清除添加药品前输入症状和疾病诊断
          this.customSymptomTags = [];
          this.customDiagnoseTags = [];
        }
      } catch (error) {
        console.log(error);
      }
    },
    async fetchDrugTags() {
      const drugIds = this.drugInfoList.map(drug => drug.drugId).join(',');
      await this.isHighRiskDrug(drugIds);
      Fetch.get_symptoms_and_illnesses_tag(drugIds).then(({ illnesses = [], symptoms = [] }) => {
        this.symptomTags = symptoms.map(v => ({ text: v, active: false }));
        this.showSymptomTags = mergeTags(
          this.symptomTags.filter((o, i) => i < 8),
          this.customSymptomTags
        );
        this.diagnoseTags = illnesses.map(v => ({ text: v, active: false }));
        this.showDiagnoseTags = mergeTags(
          this.diagnoseTags.filter((o, i) => i < 8),
          this.customDiagnoseTags
        );
      });
    },
    async fetchNewDrugTags() {
      const drugIds = this.drugInfoList.map(drug => drug.drugId).join(',');
      await this.isHighRiskDrug(drugIds);
      return Fetch.get_symptoms_and_illnesses_diff_drug({ drugIds }).then(res => {
        Telescope.trackEvent({
          trackId: 'zywzpc-response-symptoms-and-illnesses',
          custom: { result: { request: drugIds, res } }
        });
        this.drugsSymptomsAndIllnesses = Array.isArray(res) ? res : [];
      });
    },
    fetchPrescriptionStatus() {
      // 处方申请未结束提示
      const self = this;
      return new Promise((resolve, reject) => {
        Fetch.getOpenAdvisoryBSide().then(advisory => {
          if (Object.keys(advisory).length > 0) {
            const { advisoryId } = advisory;
            MessageBox.confirm('您上一次的处方申请还未结束，是否继续？', '提示', {
              center: true,
              confirmButtonText: '继续处理',
              cancelButtonText: '确定结束',
              showClose: false,
              closeOnClickModal: false,
              closeOnPressEscape: false,
              beforeClose(action, instance, done) {
                switch (action) {
                  case 'confirm':
                    // 继续处理，跳转im
                    done();
                    selfJump = true;
                    self.$router.push(`/chatHome/${advisoryId}`);
                    selfJump = false;
                    break;
                  case 'cancel':
                  case 'close':
                    // 停止问诊
                    Fetch.close_advisory(advisoryId).then(_ => {
                      done();
                      return reject();
                    });
                    break;
                }
              }
            });
          } else {
            return resolve();
          }
        });
      });
    },
    handlerClickApply(type) {
      this.applyPrescription(type);
      Telescope.trackEvent({
        trackId: 'zywzpc-click-ApplyPrescription-Submit'
      });
    },
    async applyPrescription(type) {
      try {
        const validateDrugInfo = Promise.resolve(
          (this.drugInfoList.length > 0 &&
            this.drugInfoList.filter(drug => drug.mode === CARD_MODE.SAVE).length === this.drugInfoList.length) ||
            this.nwVideo
        );

        console.log('applyPrescription');

        const validateDiseaseTags = this.isOldProcess
          ? await Promise.all([
              Promise.resolve(this.showSymptomTags.filter(tag => tag.active).length > 0),
              Promise.resolve(this.showDiagnoseTags.filter(tag => tag.active).length > 0)
            ])
          : await this.$refs.multiDiseaseInfo?.checkForms();

        const [patientInfo, drugValid, diseaseInfos, hepatonephricValid, diseaseHistoryValid, medicalRecordImgValid] =
          await Promise.all([
            this.$refs.patientInfo && this.$refs.patientInfo.validatePatientInfo(),
            validateDrugInfo,
            validateDiseaseTags,
            this.hepatonephricStatus,
            this.diseaseHistoryStatus ? this.diseaseHistory.length > 0 : true,
            this.remindLevel === 99 ? this.medicalRecordImg.length > 0 : true
          ]);

        if (!drugValid) {
          if (!this.drugInfoList.length) {
            this.showDrugInfoError = true;
          } else {
            const ids = this.drugInfoList.filter(drug => drug.mode !== CARD_MODE.SAVE).map(o => o.id);
            ids.forEach(id => {
              this.$refs.drugInfo && (this.$refs.drugInfo.$refs[`card${id}`][0].saveError = true);
            });
          }
        }

        let diseaseValid = true;

        if (this.isOldProcess) {
          const [symptomValid, diagnoseValid] = diseaseInfos;
          if (!symptomValid) {
            this.showSymptomError = true;
            diseaseValid = false;
          }

          if (!diagnoseValid) {
            this.showDiagnoseError = true;
            diseaseValid = false;
          }
        } else {
          diseaseValid = diseaseInfos.valid;
        }

        if (!hepatonephricValid) {
          await this.$alert('由于您的肝肾功能异常，暂不支持线上开具处方，建议您前往线下实体医院接受诊疗。', {
            customClass: 'hint',
            center: true,
            confirmButtonText: '知道了'
          });
        }

        if (!diseaseHistoryValid) {
          this.$message.info('请选择过往病史');
        }

        if (!medicalRecordImgValid) {
          this.$message.info('请选择上传病历');
        }

        // 发起咨询单
        if (
          patientInfo.valid &&
          drugValid &&
          diseaseValid &&
          hepatonephricValid &&
          diseaseHistoryValid &&
          medicalRecordImgValid
        ) {
          this.dialogVisible = true;
          // 问诊是否结束校验
          // await this.fetchPrescriptionStatus();
          const advisoryType = type || this.$route.params.consultType;

          const {
            showSymptomTags,
            showDiagnoseTags,
            drugInfoList,
            hepatonephricStatus,
            diseaseHistoryStatus,
            diseaseHistory,
            medicalRecordImg,
            nwVideo,
            userInfo,
            hepatonephricConfig,
            modifyRestriction
          } = this;

          const { name: applyName, mobile: applyMobile } = userInfo;

          const {
            ages: age,
            weight,
            gender,
            idNo,
            name,
            phoneNumber,
            guardianMobile,
            guardianName,
            patientType,
            verifyCode
          } = patientInfo.params;

          const symptom =
            showSymptomTags
              .filter(tag => tag.active)
              .map(o => o.text.trim())
              .join() || null;

          const illness =
            showDiagnoseTags
              .filter(tag => tag.active)
              .map(o => o.text.trim())
              .join() || null;

          let longitudeLatitude = {
            result: {
              position: null
            }
          };

          try {
            longitudeLatitude = await getLocationByAMap();
          } catch (err) {
            Telescope.trackEvent({
              trackId: 'zywzpc-apply-prescription-location',
              custom: {
                err
              }
            });
            console.log('经纬度未找到时，继续申请咨询单');
          }

          const {
            result: { position }
          } = longitudeLatitude;

          const prescriptionDetails = drugInfoList.map(
            ({
              drugBarcodeId,
              drugRemarks,
              num,
              drugId,
              drugProductDTOS: [
                { takingDay, drugUsage, drugBarcodeDTOS, id, companyId, isIntegrity, usageAndDosage, ...rest }
              ]
            }) => ({
              ...rest,
              num,
              dose: takingDay,
              usage: drugUsage,
              drugProductId: id,
              drugBarcodeId,
              barcode: drugBarcodeDTOS && drugBarcodeDTOS[0] ? drugBarcodeDTOS[0].barcode : undefined,
              remark: drugRemarks,
              symptom: diseaseInfos.infos?.find(o => o.drugId === drugId)?.info.symptoms.join(),
              illness: diseaseInfos.infos?.find(o => o.drugId === drugId)?.info.illnesses.join()
            })
          );
          Telescope.trackEvent({
            trackId: 'zywzpc-selected-drugs',
            custom: {
              drugIds: drugInfoList?.map(o => o?.drugProductDTOS?.map(o => ({ drugId: o?.drugId, name: o?.name })))
            }
          });

          Telescope.trackEvent({
            trackId: 'zywzpc-selected-drugs-gnu',
            custom: { drugIds: drugInfoList?.map(o => ({ drugId: o?.drugId, name: o?.name })) }
          });

          Telescope.trackEvent({
            trackId: 'zywzpc-selected-symptom-and-illness',
            custom: { symptomAndIllness: diseaseInfos?.infos }
          });

          const params = {
            age,
            gender,
            weight,
            idNo,
            name,
            patientMobile: phoneNumber,
            guardianMobile,
            guardianName,
            symptom,
            illness,
            applySource: 1,
            advisoryType,
            prescriptionDetails,
            platformCheck: true,
            prescriptionSource: 2,
            agreement: true,
            liverFunction: hepatonephricConfig ? (hepatonephricStatus ? 'NORMAL' : 'ABNORMAL') : null,
            renalFunction: hepatonephricConfig ? (hepatonephricStatus ? 'NORMAL' : 'ABNORMAL') : null,
            diseaseHistory: diseaseHistoryStatus ? diseaseHistory.map(o => o.replace('其他', '')) : null,
            medicalRecordImg: medicalRecordImg.length > 0 ? medicalRecordImg.map(o => o.remoteUrl).join() : null,
            hepatonephricStatus,
            videoBeforeAppendDetails: nwVideo,
            longitudeLatitude: position ? `${position.lng},${position.lat}` : '',
            applyName,
            applyMobile,
            patientType,
            verifyCode,
            centerVideoVersion: 1,
            modifyRestriction
          };

          this.applyType = type;
          let { code, msg } = await Fetch.applyAdvisoryPreCheck({
            patientMobile: params.patientMobile || params.guardianMobile,
            drugList: params.prescriptionDetails.map(x => x.name).filter(Boolean),
            verifyCode: params.verifyCode,
            prescriptionSource: 2
          });
          if (code === 'NEED_POP') {
            this.showCodeMobile = params.patientMobile;
            this.showSendCodeMsg = msg;
            this.showSendCode = true;
            return;
          }

          const wechatAdvResult = await Fetch.wechat_apply_advisory(params);
          const { imGroupId, advisoryId, doctorName, prescriptionId, doctorId, openAdvisoryResultVO } = wechatAdvResult;
          this.dialogVisible = false;
          this.wechatAdvResult = wechatAdvResult;
          Telescope.trackEvent({
            trackId: 'zywzpc-applyprescription-res',
            custom: {
              wechatAdvResult,
              path: this.$route.path
            }
          });
          if (!openAdvisoryResultVO) {
            if (advisoryType == CONSULT_TYPE.VIDEO_CONSULT) {
              /** ****************** 主动抛出接口异常，方便排查问题  *****************************/
              if (!doctorId) {
                return new Error('doctorId为空，请检查wechat_apply_advisory接口');
              }

              if (!doctorName) {
                return new Error('doctorName为空，请检查wechat_apply_advisory接口');
              }
              /***************************************************************************/

              const { userName } = userInfo;
              const groupId = imGroupId;
              const groupTitle = `${patientInfo.params.name || wechatAdvResult.patientName}的用药咨询`;
              // const custom = {
              //   data: {
              //     callName: userName,
              //     message: `${userName}邀请你进行视频`,
              //     groupId: imGroupId,
              //     groupTitle: `${patientInfo.params.name || wechatAdvResult.patientName}的用药咨询`,
              //     prescriptionId: prescriptionId,
              //     videoFrom: 'DOCTOR'
              //   }
              // };
              // await this.$store.dispatch(
              //   'video_trtcVideoStore/makeCall',
              //   {
              //     contactId: doctorId.toString(),
              //     business: custom,
              //     bizNo: prescriptionId,
              //     scene: 'DRUGSTORE_PATIENT_TO_DOCTOR'
              //   },
              //   { root: true }
              // );
              const custom = {
                callName: userName,
                groupId,
                message: `${userName}邀请你进行视频`,
                groupTitle,
                prescriptionId,
                videoFrom: 'DOCTOR'
              };
              this.$store.dispatch('video_trtcVideoStore/loginTRTCAccount', {});
              setTimeout(() => {
                if (doctorId) {
                  this.$store.dispatch(
                    'video_controller/makeCall',
                    {
                      contactId: doctorId.toString(),
                      business: custom,
                      bizNo: prescriptionId,
                      scene: 'DRUGSTORE_PATIENT_TO_DOCTOR'
                    },
                    { root: true }
                  );
                }
              }, 1000);
            }

            selfJump = true;
            await this.$router.replace(`/chatHome/${advisoryId}`);
            selfJump = false;
          } else {
            const { advisoryId: oldAdvisoryId } = openAdvisoryResultVO;
            await this.$confirm('您上一次的处方申请还未结束，是否继续？', '提示', {
              center: true,
              confirmButtonText: '继续处理',
              cancelButtonText: '确定结束',
              showClose: false,
              closeOnClickModal: false,
              closeOnPressEscape: false,
              beforeClose: (action, instance, done) => {
                switch (action) {
                  case 'confirm':
                    // 继续处理，跳转im
                    done();
                    this.$router.push(`/chatHome/${oldAdvisoryId}`);
                    break;
                  case 'cancel':
                  case 'close':
                    // 停止问诊
                    Fetch.close_advisory(oldAdvisoryId).then(_ => {
                      done();
                    });
                    break;
                }
              }
            });
          }
        }
      } catch (error) {
        if (error?.msg) {
          this.$message.info(error.msg);
        }

        if (error?.event?.name === 'NotAllowedError') {
          this.$message.info('请允许浏览器权限');
        }

        this.dialogVisible = false;
        await this.$store.dispatch('video/setVideoInital');
        throw error;
      }
    },
    getServicePrice() {
      return Fetch.get_service_price().then(({ picturePrice, videoPrice }) => {
        if (this.$route.params.consultType == CONSULT_TYPE.SIMPLE_CONSULT) this.price = picturePrice;
        if (this.$route.params.consultType == CONSULT_TYPE.VIDEO_CONSULT) this.price = videoPrice;
      });
    },
    getLeisureDoctors(params) {
      return new Promise(async (resolve, reject) => {
        try {
          let { isStartLocalCamera } = this;
          let doctors = await Fetch.get_leisure_doctors_by_query(params);
          // 打开本地摄像头
          if (isStartLocalCamera) {
            if (isEmpty(doctors)) {
              setTimeout(async () => {
                resolve(await this.getLeisureDoctors(params));
              }, 1000);
            } else {
              console.log('doctors', doctors);
              resolve(doctors);
            }
          } else {
            return new Error('取消电话');
          }
        } catch (error) {
          reject(error);
        }
      });
    },
    applyAdvisoryPageInit() {
      return Fetch.applyAdvisoryPageInit().then(({ hepatonephricConfig, maxAge, modifyRestriction }) => {
        this.hepatonephricConfig = hepatonephricConfig;
        this.maxAge = maxAge;
        this.hasModifyRestriction = modifyRestriction;
      });
    },
    changePastHistory(val) {
      this.diseaseHistory = val;
    },
    initPastHistory(pastHistory) {
      if (pastHistory && pastHistory.length > 0) {
        this.diseaseHistoryStatus = true;
        const otherDisease = pastHistory.filter(o => !['糖尿病', '高血压', '高血脂'].includes(o));
        if (otherDisease.length > 0) {
          this.diseaseHistory = pastHistory.map(o => {
            if (!['糖尿病', '高血压', '高血脂'].includes(o)) {
              return `其他${o}`;
            } else {
              return o;
            }
          });
        } else {
          this.diseaseHistory = pastHistory;
        }
      } else {
        this.diseaseHistoryStatus = false;
        this.diseaseHistory = [];
      }
    },
    async checkCaseHistoryUploadRemind() {
      const { drugInfoList, userInfo } = this;
      const { formData } = this.$refs.patientInfo;

      const storeId = userInfo?.applyPrescriptionStoreId;

      const { age, gender } = formData;

      const drugInfos = drugInfoList
        .filter(item => item.mode !== 'new') // 如果mode为new，则不存在drugProductDTOS字段，直接过滤，否则会报错
        .map(
          ({
            num,
            drugProductDTOS: [
              {
                drugId,
                takingDay,
                drugUsage,
                drugBarcodeDTOS,
                perNum,
                id,
                companyId,
                isIntegrity,
                usageAndDosage,
                ...rest
              }
            ]
          }) => ({
            num,
            takingDay,
            perName: perNum,
            usage: drugUsage,
            ...rest
          })
        );

      const { remindLevel } = await Fetch.checkCaseHistoryUploadRemind({
        drugInfos,
        age,
        gender,
        storeId
      });

      this.remindLevel = remindLevel;
    },
    onSendClose() {
      this.showSendCode = false;
    },
    onSendSuccess() {
      this.showSendCode = false;
      this.applyPrescription(this.applyType);
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      const { consultType } = to.params;
      vm.secondName = prescriptionTypeNames[consultType];
    });
  },
  beforeRouteLeave(to, from, next) {
    if (selfJump) {
      MessageHint.hide();
      // 离开页面时，保存页面实例，以备在需要时，用户返回时存在数据
      this.$store.dispatch('tagsView/addView', { name: 'applyPrescription', meta: { title: '' } }).then(() => {
        next();
      });
    } else {
      console.log('from', from);
      setTimeout(() => {
        this.$confirm('已填写的信息失效', '中断申请处方？', {
          confirmButtonText: '继续填写',
          cancelButtonText: '仍要放弃',
          customClass: 'confirm',
          distinguishCancelAndClose: true,
          center: true
        })
          .then(() => {
            return false;
          })
          .catch(action => {
            if (action == 'cancel') {
              MessageHint.hide();
              next();
            }
          });
      }, 0);
    }
  }
};
</script>

<style lang="scss" scoped>
.apply-prescription {
  position: relative;

  // .title-area {
  //   margin-bottom: 16px;
  // }

  .main-title {
    line-height: 30px;
  }

  .price {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    margin-left: 8px;
    width: 67px;
    height: 16px;
    color: #8a7446;
    font-size: 12px;
    font-weight: 600;
    background: linear-gradient(140deg, rgba(237, 229, 204, 1) 0%, rgba(217, 194, 147, 1) 100%);
    border-radius: 4px 0 4px 0;
  }

  .prescription-wrapper {
    background: #fff;
    border: 1px solid #f2f2f2;
    box-shadow: 0 4px 12px 0 #ededed;
    border-radius: 4px;
    min-height: 618px;
    padding: 20px 16px;

    /deep/.el-card__body {
      padding: 0;
    }
  }

  .ai-loading-dialog {
    /deep/ .el-dialog__header {
      padding: 0;
    }
    /deep/ .el-dialog__body {
      padding: 0;
    }
    .loading-content {
      height: 158px;
      background: white;
      border-radius: 8px;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      .loading-icon {
        margin-top: 10px;
        width: 100px;
        height: 100px;

        img {
          width: 100%;
          height: 100%;
        }
      }
      .loading-message {
        white-space: nowrap;
        font-size: 15px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        height: 20px;
        line-height: 20px;
        color: rgba(112, 112, 112, 1);
      }
    }
  }
}
</style>
